import http from '@/http';

const buscarNormas = (cdProjeto) => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/buscarNormas/' + cdProjeto)
      .then((response) => {
        resolve(response.data);
      })
  })
}

const buscarLimitesNormas = (cdProjeto) => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/buscarLimitesNormas/' + cdProjeto)
      .then((response) => {
        resolve(response.data);
      })
  })
}

const buscarCidades = () => {
  return new Promise((resolve) => {
    http.get('api/regiao/buscarCidades')
      .then((response) => {
        resolve(response.data);
      });
  });
}

const buscarComprovante = (sqUpload) => {
  return new Promise((resolve) => {
    http.get('api/rdv/buscarComprovante/' + sqUpload)
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  });
}

const buscarMesReferencia = () => {
  return new Promise((resolve, reject) => {
    http.get("api/cooperado/buscarMesReferencia")
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        reject(err);
      });
  });
}

const buscarProjetosPorReferencia = (dt_referencia) => {
  return new Promise((resolve, reject) => {
    http.get("api/cooperado/buscarProjetosPorReferencia", { params: { dt_referencia } })
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        reject(err);
      });
  });
}

const buscarProjetos = () => {
  return new Promise((resolve, reject) => {
    http.get("api/cooperado/filtrarProjeto")
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        reject(err);
      });
  });
}


const buscarDespesas = (cdRdv) => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/buscarDespesas/' + cdRdv)
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}

const buscarCarteiras = (cdRdv) => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/buscarCarteiras/' + cdRdv)
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}

const buscarAdiantamentos = (cdRdv) => {
  return new Promise((resolve, reject) => {
    http.get("api/rdvCooperado/adiantamento/buscarAdiantamentos/" + cdRdv)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const buscarTransacaoVisa = (idTransacao, cdRdv) => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/visa/buscarTransacao/' + idTransacao + '/' + cdRdv)
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}

const buscarTransacaoMaster = (idTransacao, cdRdv) => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/masterCard/buscarTransacao/' + idTransacao + '/' + cdRdv)
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}


const buscarTransacaoGoodCard = (idTransacao, cdRdv) => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/goodCard/buscarTransacao/' + idTransacao + '/' + cdRdv)
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}

const buscarTransacaoTicketLog = (idTransacao, cdRdv) => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/ticketLog/buscarTransacao/' + idTransacao + '/' + cdRdv)
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}

const buscarParametros = () => {
  return new Promise((resolve) => {
    http.get('api/rdvCooperado/buscarParametros')
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}

const buscaTipoCombustivel = () => {
  return new Promise((resolve) => {
    http.get('api/rdv/buscaTipoCombustivel')
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}

const excluirAdiantamento = (item) => {
  return new Promise((resolve, reject) => {
    http.post("api/rdvCooperado/adiantamento/remover", {
      sq_lcto: item.sq_lcto_adiantamento,
      sq_lancamento: item.sq_lancamento,
      dt_lancamento: item.dt_lancamento,
      nr_credito: item.nr_credito_adiantamento,
      sq_credito: item.sq_credito_adiantamento,
      cd_rdv: item.cd_rdv
    })
      .then(() => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      })
  })
}

const excluirRecursoProprio = (item) => {
  return new Promise((resolve, reject) => {
    http.post("api/rdvCooperado/recursoProprio/remover", {
      sq_tipo_recurso_proprio: item.sq_tipo_recurso_proprio,
      sq_lcto: item.sq_lcto_recurso_proprio,
      dt_lcto: item.dt_lancamento,
      cd_projeto: item.cd_projeto,
      cd_rdv: item.cd_rdv,
      sq_lancamento: item.sq_lancamento
    })
      .then(() => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      })
  })
}

const excluirMastercard = (item) => {
  return new Promise((resolve, reject) => {
    http.post("api/rdvCooperado/masterCard/remover", {
      nr_financial_transaction_id: parseInt(item.id_mastercard_transacao),
      sq_lcto: parseInt(item.sq_lcto_mastercard_transacao),
      cd_rdv: item.cd_rdv,
      sq_lancamento: item.sq_lancamento
    })
      .then(() => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      })
  })
}

const excluirVisa = (item) => {
  return new Promise((resolve, reject) => {
    http.post("api/rdvCooperado/visa/remover", {
      nr_financial_transaction_id: parseInt(item.id_visa_transacao),
      sq_lcto: parseInt(item.sq_lcto_visa_transacao),
      cd_projeto: parseInt(item.cd_projeto),
      cd_rdv: item.cd_rdv,
      sq_lancamento: item.sq_lancamento
    })
      .then(() => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      })
  })
}

const incluirMotivoFalta = (rdvInfo, motivo, justificativaCooperado) => {
  var sequencia = "";
  switch (rdvInfo.ds_carteira) {
    case "Visa":
      sequencia = rdvInfo.id_visa_transacao;
      break;
    case "Mastercard":
      sequencia = rdvInfo.id_mastercard_transacao;
      break;
    case "Good Card":
      sequencia = rdvInfo.sq_lcto_utilizacao_frota;
      break;
    case "Ticket Log":
      sequencia = rdvInfo.sq_lcto_utilizacao_frota;
      break;
  }

  return new Promise((resolve, reject) => {
    http.post("api/rdvCooperado/justificativa/incluirMotivoFalta", {
      carteira: rdvInfo.ds_carteira,
      sequencia: sequencia,
      motivo: motivo ? motivo.sq_transacao_motivo_falta : null,
      justificativa: justificativaCooperado,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export {
  buscarNormas,
  buscarCidades,
  buscarComprovante,
  buscarLimitesNormas,
  buscarProjetos,
  buscarDespesas,
  buscarCarteiras,
  excluirAdiantamento,
  excluirRecursoProprio,
  excluirMastercard,
  excluirVisa,
  buscarAdiantamentos,
  buscarTransacaoVisa,
  buscarTransacaoMaster,
  buscarTransacaoGoodCard,
  buscarTransacaoTicketLog,
  incluirMotivoFalta,
  buscarParametros,
  buscarMesReferencia,
  buscarProjetosPorReferencia,
  buscaTipoCombustivel
}